import zod from "zod";

export const SubscribeToNewsletterValidationSchema = zod.object({
  "email-address": zod.string().email(),
});
